<template>
  <tr
    :style="!tableMin ? 'cursor:pointer' : ''"
    @click="
      !tableMin &&
        $router.push({
          name: 'PersonalAreaEmployee',
          params: { userId: item.user.id },
        })
    "
  >
    <td>
      <div class="d-grid grid-col-max-auto align-center gap-2 f18">
        <EmployeesPhoto
          :size="30"
          :img="item.user.photo"
          :textFirst="item.user.first_name"
          :textSecond="item.user.last_name"
        />
        {{ item.user.first_name + ' ' + item.user.last_name }}
      </div>
      <div class="show" v-if="tableMin">
        <BaseButton
          @click="
            $router.push({
              name: 'PersonalAreaEmployee',
              params: { userId: item.user.id },
            })
          "
          minimalize
          icon_only
          default_icon="button-show"
          size="50"
        />
      </div>
    </td>
    <td class="f18">
      {{ item.user.work_role ? item.user.work_role.name : '—' }}
    </td>
    <td>
      <div class="status f13">
        {{ localStorage.translations.pages.common.text['net-dannyh'] }}
      </div>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import EmployeesPhoto from 'components/employees/EmployeesPhoto'

export default {
  name: 'EmployeesGroupTableItem',
  components: {
    EmployeesPhoto,
  },
  props: { item: Object, tableMin: Boolean },
  computed: {
    ...mapGetters('workTypeCategory', ['workTypeCategoryGridAll']),
    ...mapGetters('workClientProjectsWorkType', ['workClientProjectsWorkTypeAll_project']),
  },
}
</script>

<style lang="scss" scoped>
tr{
  cursor: pointer;
  td {
    font-weight: normal;
    color: #323c47 !important;
    //height: 64px !important;
    padding: 10px 16px !important;
    
    .fullSize {
      width: 100%;
      height: 100%;
      display: grid;
      justify-content: center;
      align-items: center;
    }
    .employee {
      background-color: #277faf;
      width: max-content;
      padding: 5px 12px;
      border-radius: 12px;
      color: #ffffff;
      &:not(:last-of-type) {
        margin-bottom: 5px;
      }
    }
    .status {
      background-color: #bbbbbb;
    }
  }
}
</style>
